export default "__VITE_ASSET__60JDJXX9__"